import { Component, OnInit } from "@angular/core";

import { AccountService } from "projects/sepidz-web-framework/src/lib/services";
import { ActivatedRoute } from "@angular/router";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { ShowToastrService } from "projects/sepidz-web-framework/src/lib/services/show-toastr.service";
import { MisSetUp } from "projects/sepidz-web-framework/src/lib/models/missetup.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "ngx-missetup",
  templateUrl: "./missetup.component.html",
  styleUrls: ["./missetup.component.scss"],
})
export class MissetupComponent implements OnInit {
  model = <MisSetUp>{};
  public isNewRow = false;
  public showValidationErrors: boolean = true;

  public changesSavedCallback: () => void;
  public changesFailedCallback: () => void;
  public changesCancelledCallback: () => void;

  label: string;

  public apiName: string = "MisSetUp";
  constructor(
    public missetup: MisSetupService,
    private sts: ShowToastrService,
    protected route: ActivatedRoute,
    protected accountService: AccountService,
    private translateservice: TranslateService
  ) {}

  ngOnInit(): void {
    this.label = this.translateservice.instant("ClientApp.GNR.MisSetup.GeneralSetting");
    this.missetup.isLoding = false;
    this.getall();
  }
  public save() {
    this.missetup.save();
  }

  public cancel() {
    this.sts.showToast(
      "primary",
      this.translateservice.instant("ClientApp.GNR.MisSetup.Cancel"),
      this.translateservice.instant("ClientApp.GNR.MisSetup.StopWithOprator")
    );
  }
  getall() {
    this.missetup.getall();
  }
}
